import {
  CommonHelperFunctions,
  ICreateWorkflowStartScreenRequest,
  ICreateWorkflowStartScreenResponse,
  ICRUDFormDiMetadata,
  IUnlinkScreenRequest,
  IUpdateWorkflowScreensProgress,
  IUpdateWorkflowScreensRequest,
  IUpdateWorkflowScreensResponse
} from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";
import { FormService } from "./form-service";
import { StreamingHelperService } from "./streaming-helper-service";

declare let window: Window & { kuika: any; userInfo: any };

export class WorkflowScreenService {
  static backendUrl: string = CommonHelperFunctions.GetBackendUrl();

  public static async UnlinkScreen(request: IUnlinkScreenRequest): Promise<AxiosResponse<void>> {
    try {
      const url: string = `${WorkflowScreenService.backendUrl}/workflowscreen/unlinkscreen`;
      const res = await Axios.post<IUnlinkScreenRequest, AxiosResponse<void>>(url, request);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetFormMetadataOfScreen(
    screenId: string,
    fallbackOptions?: { processId: string; stepId: string }
  ): Promise<AxiosResponse<ICRUDFormDiMetadata>> {
    try {
      const url: string = `${WorkflowScreenService.backendUrl}/workflowscreen/getformmetadataofscreen/${screenId}`;
      const res = await Axios.get<{}, AxiosResponse<ICRUDFormDiMetadata>>(url);
      return res;
    } catch (error: any) {
      if (fallbackOptions) {
        const response = await FormService.GetFormMetadataFromWorkflowBo({
          processId: fallbackOptions.processId,
          stepId: fallbackOptions.stepId
        });

        return response;
      }
      KMainFunctions.exceptionHandler(error);

      return error;
    }
  }

  public static async UpdateWorkflowScreens(
    request: IUpdateWorkflowScreensRequest
  ): Promise<AxiosResponse<IUpdateWorkflowScreensResponse>> {
    try {
      const res = await Axios.post<IUpdateWorkflowScreensRequest, AxiosResponse<IUpdateWorkflowScreensResponse>>(
        `${WorkflowScreenService.backendUrl}/workflowscreen/updateworkflowscreens`,
        request
      );
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UpdateWorkflowScreensWithProgress(
    request: IUpdateWorkflowScreensRequest,
    onProgress?: (progress: IUpdateWorkflowScreensProgress) => void
  ): Promise<IUpdateWorkflowScreensResponse> {
    return StreamingHelperService.streamRequest<IUpdateWorkflowScreensResponse>(
      `${WorkflowScreenService.backendUrl}/workflowscreen/updateworkflowscreens/stream`,
      {
        method: "POST",
        body: JSON.stringify(request)
      },
      onProgress
    );
  }

  public static async CreateWorkflowStartScreen(
    request: ICreateWorkflowStartScreenRequest
  ): Promise<AxiosResponse<ICreateWorkflowStartScreenResponse>> {
    try {
      const url: string = `${WorkflowScreenService.backendUrl}/workflowscreen/createworkflowstartscreen`;
      const res = await Axios.post<
        ICreateWorkflowStartScreenRequest,
        AxiosResponse<ICreateWorkflowStartScreenResponse>
      >(url, request);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
